import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CloseIcon } from '$icons/CloseGreen.svg';
import { ReactComponent as RightArrow } from '$icons/ArrowRight.svg';
import Button from '$components/Buttons/Button';
import ModalInTailwind from '$components/ModalInTailwind/ModalInTailwind';
import { useGetAllCurrenciesQuery } from '$store/modules/currencies';
import { useCurrency } from '$hooks/useCurrency';

const DEFAULT_CURRENCY_CODE = 'USD';

type ShareCurrencyModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  onConfirm: (currencyCode: string) => void;
};

const ShareCurrencyModal: FC<ShareCurrencyModalProps> = ({
  isOpen,
  closeModal,
  onConfirm,
}) => {
  const [t] = useTranslation('global');
  const { data: currencies } = useGetAllCurrenciesQuery();
  const { selectedCode } = useCurrency();
  const [currencyCode, setCurrencyCode] = useState(
    selectedCode || DEFAULT_CURRENCY_CODE
  );

  useEffect(() => {
    if (isOpen) setCurrencyCode(selectedCode || DEFAULT_CURRENCY_CODE);
  }, [isOpen, selectedCode]);

  const handleConfirm = () => {
    onConfirm(currencyCode);
    closeModal();
  };

  return (
    <ModalInTailwind isOpen={isOpen} closeModal={closeModal}>
      <div className="flex flex-col bg-white p-8 w-96 rounded">
        <header className="flex flex-row justify-between items-center mb-4 w-full">
          <div className="text-xl font-bold whitespace-nowrap">
            {t('ShareCurrencyModal.Title')}
          </div>
          <button aria-label="Close" type="button" onClick={closeModal}>
            <CloseIcon />
          </button>
        </header>
        <div className="flex flex-col w-full">
          <h3 className="text-lg font-semibold">
            {t('ShareCurrencyModal.DisplayCurrency')}
          </h3>
          <select
            className="border rounded w-full p-2 mb-4"
            value={currencyCode}
            onChange={(e) => setCurrencyCode(e.target.value)}
          >
            {currencies?.map((c) => (
              <option key={c.Code} value={c.Code}>
                {c.Name}
              </option>
            ))}
          </select>
          <div className="flex flex-row mt-2 self-end w-60">
            <Button
              text={t('ShareCurrencyModal.Cancel')}
              showText
              textStyles={{ color: '#079e88' }}
              onClick={closeModal}
            />
            <Button
              text={t('ShareCurrencyModal.CopyLink')}
              icon={RightArrow}
              invertTextContent
              showText
              bgColor="#079e88"
              onClick={handleConfirm}
            />
          </div>
        </div>
      </div>
    </ModalInTailwind>
  );
};

export default ShareCurrencyModal;
